<template>
  <div class="main_Container" id="page" @scroll="handleScroll">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addCodeModal"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة كود جديد
            </button>
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addCodesModal"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة اكواد جديد
            </button>
            <button
              class="btn add"
              v-if="lastBatchId"
              @click="printLastBatch()"
            >
              <i class="fas fa-print ms-1"></i>
              طباعة آخر دفعة
            </button>
            <!-- Add Code Modal Start -->
            <div
              class="modal fade"
              id="addCodeModal"
              tabindex="-1"
              aria-labelledby="addCodeModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة كود</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form
                      id="addInfograph"
                      @submit.prevent="addNewCode($event)"
                    >
                      <div class="form-group">
                        <label for="codePrice">السعر</label>
                        <input
                          type="number"
                          class="form-control mt-2"
                          placeholder="السعر"
                          id="codePrice"
                          v-model="code.amount"
                          required
                        />
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <span>سيريال: </span>
                          <span>{{ generateSerial(10) }}</span>
                        </div>
                      </div>

                      <div class="form-group text-start mt-4">
                        <button type="submit" class="btn add w-100">
                          أضافة
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Code Modal End -->
            <!------------------------------->
            <!-- Add Codes Modal Start -->
            <div
              class="modal fade"
              id="addCodesModal"
              tabindex="-1"
              aria-labelledby="addCodesModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة اكثر من كود</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form
                      id="addInfograph"
                      @submit.prevent="addNewCodes($event)"
                    >
                      <div class="form-group">
                        <label for="codePrice">السعر</label>
                        <input
                          type="number"
                          class="form-control mt-2"
                          placeholder="السعر"
                          id="codePrice"
                          v-model="code.amount"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label for="codesNumber">عدد الاكواد</label>
                        <input
                          type="number"
                          class="form-control mt-2"
                          placeholder="عدد الاكواد"
                          id="codesNumber"
                          v-model="numbersOfCodes"
                          required
                        />
                      </div>

                      <div class="form-group text-start mt-4">
                        <button type="submit" class="btn add w-100">
                          أضافة
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Codes Modal End -->

            <!-- Sort -->
            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-sort ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ الانشاء
                </li>
                <li class="dropdown-item" @click="sortByDateOfUsage">
                  ترتيب حسب التاريخ الانتهاء
                </li>
              </ul>
            </div>

            <!-- Filter -->
            <button
              class="btn me-2 add"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <i class="fas fa-filter ms-1"></i>
              فلتر
            </button>
            <div
              class="modal fade"
              tabindex="-1"
              id="filterModal"
              aria-labelledby="filterModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <form @submit.prevent="filteredSelectData($event)">
                    <div class="modal-header">
                      <h5 class="modal-title">اعادة تصنيف</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="filter"
                              id="filterOne"
                              :value="true"
                              v-model="filter"
                            />
                            <label class="form-check-label" for="filterOne"
                              >تم الاستخدامة</label
                            >
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="filter"
                              id="filterTwo"
                              v-model="filter"
                              :value="null"
                            />
                            <label class="form-check-label" for="filterTwo"
                              >لم يتم استخدامة</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn delete"
                        data-bs-dismiss="modal"
                        @click="removeFiltered()"
                      >
                        أعادة تعيين
                      </button>
                      <button type="submit" class="btn add">تنفيذ</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <Transition name="scale" mode="out-in">
            <div class="table__select" v-if="this.checkedCodes.length > 0">
              <div class="table__select__count">
                تم تحديد {{ this.checkedCodes.length }}
              </div>
              <div class="table__select__buttons">
                <button class="btn delete" @click="deleteCodesList()">
                  <i class="fas fa-trash-alt ms-2"></i>
                  حذف
                </button>
                <button class="btn print" @click="printMultiPDF()">
                  <i class="fas fa-print ms-2"></i>
                  طباعة
                </button>
              </div>
            </div>
          </Transition>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    readonly
                    data-bs-toggle="modal"
                    data-bs-target="#searchModal"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                  />
                </div>
              </div>
            </form>
            <!-- search modal -->
            <div
              class="modal fade"
              tabindex="-1"
              id="searchModal"
              aria-labelledby="searchModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">بحث في الاكواد</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <ais-instant-search
                    :search-client="searchClient"
                    index-name="Codes"
                    class="p-4"
                  >
                    <ais-search-box
                      placeholder="هل تبحث عن ...."
                      class="mb-4 searchbox"
                    />

                    <div class="table-responsive">
                      <ais-configure :hits-per-page.camel="10">
                        <ais-hits>
                          <template v-slot="{ items }">
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th class="fit" scope="col">الرقم</th>
                                  <th class="fit" scope="col">السعر</th>
                                  <th scope="col">الكود</th>
                                  <th scope="col">السيريال</th>
                                  <th scope="col">تاريخ الانتهاء</th>
                                  <th scope="col">التحكم</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-if="!items.length">
                                  <td colspan="6">
                                    <div class="empty-state">
                                      <div class="empty-state__icon">
                                        <i class="fas fa-folder"></i>
                                      </div>
                                      <h3 class="empty-state__text">
                                        لا يوجد اكواد حتى الآن
                                      </h3>
                                    </div>
                                  </td>
                                </tr>
                                <tr
                                  v-for="(item, index) in items"
                                  :key="index"
                                  v-else
                                >
                                  <th scope="row">{{ index + 1 }}</th>
                                  <td>{{ item.amount }}</td>
                                  <td>{{ item.code }}</td>
                                  <td>{{ item.serial }}</td>
                                  <td>
                                    <div v-if="item.date_of_usage == null">
                                      لم يتم استخدام الكود
                                    </div>
                                    <div v-else>
                                      تم الاستخدام فى
                                      {{
                                        item.date_of_usage &&
                                        changeTimeFormat(
                                          new Date(item.date_of_usage)
                                        )
                                      }}
                                    </div>
                                  </td>
                                  <td>
                                    <button
                                      class="btn print"
                                      @click="printMultiPDF(item)"
                                    >
                                      <i class="fas fa-print ms-2"></i>
                                      طباعة
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </template>
                        </ais-hits>
                      </ais-configure>
                    </div>
                    <ais-pagination class="mt-4" />
                  </ais-instant-search>
                </div>
              </div>
            </div>
            <!-- search modal -->
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="text-center" style="width: 5%" scope="col">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="allSelected"
                      @change="selectAll($event, codes)"
                    />
                  </th>
                  <th class="fit" scope="col">الرقم</th>
                  <th class="fit" scope="col">السعر</th>
                  <th scope="col">الكود</th>
                  <th scope="col">السيريال</th>
                  <th scope="col">تاريخ الانتهاء</th>
                  <th scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!codes.length">
                  <td colspan="7">
                    <div class="empty-state">
                      <div class="empty-state__icon">
                        <i class="fas fa-folder"></i>
                      </div>
                      <h3 class="empty-state__text">لا يوجد اكواد حتى الآن</h3>
                    </div>
                  </td>
                </tr>
                <tr v-for="(item, index) in codes" :key="index" v-else>
                  <th class="text-center" scope="row">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="flexCheckDefault"
                      v-model="checkedCodes"
                      @change="updateCheckall($event, codes)"
                      :value="item"
                    />
                  </th>
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ item.amount }}</td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.serial }}</td>
                  <td>
                    <div v-if="item.date_of_usage == null">
                      لم يتم استخدام الكود
                    </div>
                    <div v-else>
                      تم الاستخدام فى
                      {{
                        item.date_of_usage &&
                        changeTimeFormat(
                          new Date(item.date_of_usage.seconds * 1000)
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <button class="btn print" @click="printMultiPDF(item)">
                      <i class="fas fa-print ms-2"></i>
                      طباعة
                    </button>

                    <button
                      class="btn me-2 delete"
                      @click="deleteSelectedCode(item)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav
              class="pagination text-center"
              v-show="this.isShowButton && !this.filteredPagination"
              aria-label="Page navigation "
            >
              <button
                class="btn add"
                @click="this.getNextSelectedData"
                v-if="!this.loadingMore"
              >
                تحميل المزيد
              </button>
              <div v-else>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </nav>
            <nav
              class="pagination text-center"
              v-show="this.filteredPagination && this.isHaveMoreFilterData"
              aria-label="Page navigation "
            >
              <button
                class="btn add"
                @click="this.nextFilterData(this.filter)"
                v-if="loadMore && codes.length"
              >
                تحميل المزيد
              </button>
              <div v-else-if="isLoadingMore">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </nav>
            <div
              v-show="
                (!this.isloading && !this.codes) || this.codes.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد اكواد حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Print codes -->
    <section v-if="this.checkedCodes.length > 0">
      <div class="" id="myMultielement">
        <div
          class="pdf multi"
          v-for="(code, index) in this.checkedCodes"
          :key="index"
        >
          <img class="w-100 pdf__background" src="@/assets/code_pdf.jpg" />
          <div class="pdf__info">
            <div class="pdf__info__code">
              {{ code.code }}
            </div>
            <div class="pdf__info__serial">
              {{ code.serial }}
            </div>
            <div class="pdf__info__amount">
              {{ code.amount }}
            </div>
            <div class="pdf__info__qr">
              <qrcode-vue
                :value="code.code"
                render-as="svg"
                :size="QRCode_Size"
                level="H"
                foreground="#000"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";

// Swal
import Swal from "sweetalert2";
// Print PDF
// Generate QR-Code
import QrcodeVue from "qrcode.vue";
//
//

// import pdfMake from "pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import htmlToPdfmake from "html-to-pdfmake";
import algoliasearch from "algoliasearch/lite";
import "instantsearch.css/themes/algolia-min.css";
import { Printd } from "printd";

export default {
  data() {
    return {
      searchClient: algoliasearch(
        "T5X9XT9RRM",
        "ace6a9f5915790786628ecae3dd8032a"
      ),
      codePrint: {},
      numbersOfCodes: "",
      QRCode_Size: 250,
      isloading: false,
      firstLoad: "",
      currentView: "الاكواد",
      codes: [],
      checkedCodes: [],
      // Id of the most recently created batch, so it can be re-printed.
      lastBatchId: null,
      allSelected: false,
      code: {
        amount: "",
        date_of_usage: null,
        serial: "",
        code: "",
      },
      // Pagination
      loadingMore: false,
      isShowButton: true,
      // Search
      searchResult: [],
      // filter
      filter: "",
      filteredPagination: false,
    };
  },
  components: {
    QrcodeVue,
    //
  },
  methods: {
    //
    //
    // Printing a single row prints ONLY that row. This used to push onto
    // checkedCodes, so a row's print also printed every ticked checkbox.
    async setCode(code) {
      this.checkedCodes = [code];
    },

    async printMultiPDF(code) {
      const css = `
        html,
        body {
          height: 100%;
        }
        *,*::after,*::before{
          margin: 0;
          padding: 0;
        }
        .pdf {
          position: relative;
          width: 21cm;
          height: 29.7cm;
          display: block;
          margin: 0.5cm auto 2cm auto;
          box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
          box-sizing: border-box;
          page-break-after: always;
          overflow: hidden;
        }

        .pdf:last-child {
          page-break-after: unset;
        }

        .pdf__background {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .pdf__info {
          position: absolute;
          top: 25.5%;
          right: 0;
          width: 100%;
          height: 100%;
          z-index: 99;
          font-size: 2.3rem;
        }

        .pdf__info__code {
          position: absolute;
          margin-bottom: 18px;
          top: 10px;
          right: 300px;
        }
        .pdf__info__serial {
          position: absolute;
          right: 357px;
          top: 85px;
        }
        .pdf__info__amount {
          position: absolute;
          right: 450px;
          top: 165px;
        }
        .pdf__info__qr {
          position: absolute;
          top: 510px;
          right: 106px;
        }`;

      const d = new Printd();

      if (code != undefined) {
        await this.setCode(code);
        let table = document.getElementById("myMultielement");
        d.print(table, [css]);
      } else {
        let table = document.getElementById("myMultielement");
        d.print(table, [css]);
      }
      this.checkedCodes = [];
      this.allSelected = false;
    },

    // Vuex
    ...mapActions("codesModule", [
      "addCode",
      "addCodes",
      "deleteCode",
      "deleteCodes",
      // Pagination -- Sort -- Search
      "getFirstData",
      "getNextData",
      "changeSorting",
      // Search
      "searchData",
      // Filter
      "filterData",
      "nextFilterData",
    ]),

    // Pagination
    getNextSelectedData() {
      this.getNextData();
    },
    getPrevSelectedData() {
      this.getPrevData();
    },
    // Sort
    sortByCreateDate() {
      this.changeSorting("created_date");
      this.getFirstData();
    },
    sortByDateOfUsage() {
      this.changeSorting("date_of_usage");
      this.getFirstData();
    },

    // Filter
    async filteredSelectData(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      closeButton.click();

      await this.filterData(this.filter);
      this.codes = this.getSearchResult;
      this.filteredPagination = true;
    },

    removeFiltered() {
      this.codes = this.getCodes;
      this.searchResult = [];
      this.filteredPagination = false;
      this.filter = "";
    },

    // Search
    getDocBySeacrh(e) {
      if (e.target.value == "") {
        this.codes = this.getCodes;
        return;
      }
      this.searchData(e.target.value);
      this.codes = this.searchResult;
    },

    changeTimeFormat(time) {
      var date = new Date(time);
      return (
        date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
      );
    },

    async selectAll(e, items) {
      this.checkedCodes = [];

      if (this.allSelected) {
        const selected = items.map((code) => code);
        this.checkedCodes.push(...selected);
      } else {
        this.selected = [];
        this.checkedCodes = [];
      }
    },
    updateCheckall(e, items) {
      if (items.length == this.checkedCodes.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },

    // Builds the codes for ONE batch. This must start from an empty list:
    // when it accumulated, a second batch re-sent the first batch's documents
    // to Firestore (duplicate serials) and printed both batches together.
    buildNewBatch() {
      const codesToCreate = [];
      const count = Number(this.numbersOfCodes);

      for (let i = 0; i < count; i++) {
        codesToCreate.push({
          amount: this.code.amount,
          date_of_usage: null,
          serial: this.generateSerial(10, true),
        });
      }

      return codesToCreate;
    },

    // Add New Code List
    async addNewCodes(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      const codesToCreate = this.buildNewBatch();
      if (codesToCreate.length === 0) {
        this.showError("حدد عدد الأكواد المطلوبة");
        return;
      }

      let createdCodes;
      try {
        // addCodes returns the documents it created, each already carrying its
        // code_id / code / batch_id — so the print list is exactly this batch.
        createdCodes = await this.addCodes(codesToCreate);
      } catch (error) {
        console.error("Could not create the codes", error);
        this.showError("لم يتم إضافة الأكواد، حاول مرة اخرى");
        return;
      }

      this.lastBatchId = createdCodes[0]?.batch_id ?? null;
      this.checkedCodes = createdCodes;

      closeButton.click();
      this.clearAndShowSuccess();

      // Wait for the hidden print section to render this batch, then print.
      // This replaces a fixed 1s timeout that fired after the modal had closed.
      await this.$nextTick();
      await this.printMultiPDF();
    },

    // Re-print the most recent batch without creating anything.
    async printLastBatch() {
      if (!this.lastBatchId) return;
      const batch = this.codes.filter(
        (code) => code.batch_id === this.lastBatchId
      );
      if (batch.length === 0) {
        this.showError("لا يوجد أكواد في آخر دفعة");
        return;
      }
      this.checkedCodes = batch;
      await this.$nextTick();
      await this.printMultiPDF();
    },

    showError(title) {
      Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      }).fire({ icon: "error", title });
    },

    // Add New Code
    async addNewCode(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      await this.addCode(this.code);
      closeButton.click();
      this.clearAndShowSuccess();
    },

    // Delete Selected Code
    deleteSelectedCode(code) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا الكود؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الكود بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteCode(code.code_id);
        }
      });
    },

    // Delete List of Code
    async deleteCodesList() {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذه الاكواد؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الاكواد بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteCodes(this.checkedCodes);
          this.checkedCodes = [];
        }
      });
    },
    //---------------------------//
    // Generate Code
    generateCode(length, isMulti) {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      if (isMulti) {
        this.code.code = result;
        return result;
      }

      this.code.code = result;
      return result;
    },
    // Generate Serial
    generateSerial(length, isMulti) {
      const numbers = "0123456789";
      let result = "";
      const numbersLength = numbers.length;
      for (let i = 0; i < length; i++) {
        result += numbers.charAt(Math.floor(Math.random() * numbersLength));
      }
      const serial = this.code.serial;
      const isNotEmpty = !!serial;

      if (isMulti) {
        this.code.serial = result;
        return result;
      }

      if (!isNotEmpty) {
        this.code.serial = result;
      }
      return isNotEmpty ? this.code.serial : result;
    },
    //---------------------------//
    // Handle Add Code
    clearAndShowSuccess() {
      this.seccussAdd();
      this.clearData();
    },
    // clear Data when close modal
    clearData() {
      this.numbersOfCodes = "";
      this.code = {
        amount: "",
        date_of_usage: null,
        serial: "",
        code: "",
      };
    },
    // On Upload Image
    seccussAdd() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم إضافة الكود بنجاح",
      });
    },
    //---------------------------//
    // Code Download PDF
    onProgress(event) {
      console.log(`Processed: ${event} / 100`);
    },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    // printCode(code) {
    //   this.codePrint = code;
    //   this.$refs.html2Pdf.generatePdf();
    // },
  },

  async created() {
    if (this.isFirstLoad) await this.getFirstData();
  },

  computed: {
    ...mapGetters("codesModule", [
      "getCodes",
      "isLoading",
      "isFirstLoad",
      "loadMore",
      // Pagination
      "isLoadingMore",
      "isShowLoadingButton",
      // Search
      "getSearchResult",
      "isHaveMoreFilterData",
    ]),
  },
  mounted() {
    this.firstLoad = this.isFirstLoad;
    this.isloading = this.isLoading;
    this.codes = this.getCodes;
    // Pagination
    this.loadingMore = this.isLoadingMore;
    this.isShowButton = this.isShowLoadingButton;
    // Search
    this.searchResult = this.getSearchResult;
  },

  watch: {
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    getCodes() {
      this.codes = this.getCodes;
    },
    // Pagination
    isLoadingMore() {
      this.loadingMore = this.isLoadingMore;
    },
    isShowLoadingButton() {
      this.isShowButton = this.isShowLoadingButton;
    },
    // Search
    getSearchResult() {
      this.searchResult = this.getSearchResult;
    },
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .container-fluid {
    display: none;
  }
  .pdf {
    display: block;
  }
}
.pdf {
  display: none;
}
</style>
